import { useWindowSize } from "@vueuse/core";
import { computed } from "vue";

const PHONE_CUTOFF = 768;
const TABLET_CUTOFF = 1400; // Excludes off ipad pro in landscape mode
export function useDeviceSize() {
	const { width } = useWindowSize();

	const isPhone = computed(() => width.value < PHONE_CUTOFF);
	const isTablet = computed(
		() => width.value >= PHONE_CUTOFF && width.value < TABLET_CUTOFF,
	);
	const isDesktop = computed(() => width.value >= TABLET_CUTOFF);
	const isTabletPlus = computed(() => width.value >= PHONE_CUTOFF);

	return {
		isPhone,
		isTablet,
		isDesktop,
		isTabletPlus,
	};
}
